// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1dFBq","modalFooterButton":"ModalNotes_modalFooterButton__1sDMp"};